import { useEffect, useState } from "react";
import UserIdentitiesService, { AccessRequestDto, UserIdentityRequestStatusEnum, UserIdentityType } from "../../../services/UserIdentitiesService";
import { DefaultButton, IconButton, IIconProps, Modal, Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";
import SignaturesService, { ISignature } from "../../../services/SignaturesService";
import Auth from "../../../Auth/Auth";
import { ModalRequestAuthorizationTable, SignatureComponentWrapper } from "./ModalRequestAuthorization.style";
import moment from "moment";
import StatusPill, { getStatus } from "../../StatusPill/StatusPill";
import { SignatureComponent } from "../../Signature/SignatureComponent";

type Props = {
    showModal: boolean;
    selectedUserIdentity: UserIdentityType;
    handleSubmit?: (signatureSuccess: boolean) => any;
    userIdentitiesAccessRequest: AccessRequestDto[];
    userId: number,
    isLoading: boolean;
};

const ModalRequestAuthorization = (props: Props) => {
    const userId = Auth.getUserProfile().id;
    console.log('userId', userId);
    
    const { showModal, handleSubmit, userIdentitiesAccessRequest, selectedUserIdentity, isLoading } = props;
    const [signatureId, setSignatureId] = useState<number>();

    // TODO-hector:
    const [accessRequest, setAccessRequest] = useState<AccessRequestDto[]>(userIdentitiesAccessRequest);
    const cancelIcon: IIconProps = { iconName: 'Cancel' };

    // Firma
    const [signatures, setSignatures] = React.useState<ISignature[]>([]);
    const [isSignSubmitting, setIsSignSubmitting] = useState(false);
    const [isSignSubmitted, setIsSignSubmitted] = React.useState<boolean>(false);
    const [isLoadedSignature, setIsLoadedSignature] = useState(false);
    const [alreadySignedText, setAlreadySignedText] = React.useState<string>("Operación firmada con éxito.");
    const [validatingAcceptSignature, setValidatingAcceptSignature] = useState<boolean>(false);
    const [validatingRejectSignature, setValidatingRejectSignature] = useState<boolean>(false);
    const [showSignatureComponent, setShowSignatureComponent] = useState<boolean>(false);

    
    // activar/desactivo los botones de aceptar y rechazar
    const [disabledAcceptButton, setDisabledAcceptButton] = useState<boolean>(false);
    const [disabledRejectButton, setDisabledRejectButton] = useState<boolean>(false);

    // modal
    const handleCloseModalExistingAccount = (success: boolean) => {
        if (handleSubmit !== undefined) {
            handleSubmit(success);
        };
    };

    /*****************************************************************************
     * Estado de los botones para aceptar o rechazar la solicitud de autorización
     *****************************************************************************/
    useEffect(() => {
        if (userIdentitiesAccessRequest.length > 0) {
            setAccessRequest(userIdentitiesAccessRequest);
            // Solicitud RECHAZADA
            if(userIdentitiesAccessRequest[0].status === UserIdentityRequestStatusEnum.Rejected) {
                setDisabledAcceptButton(true);
                setDisabledRejectButton(true);
            }

            // Solicitud ACEPTADA
            if(userIdentitiesAccessRequest[0].status === UserIdentityRequestStatusEnum.Approved) {
                setDisabledAcceptButton(true);
                setDisabledRejectButton(false);
            }

            // Solicitud PENDIENTE
            if(userIdentitiesAccessRequest[0].status === UserIdentityRequestStatusEnum.Pending) {
                setDisabledAcceptButton(false);
                setDisabledRejectButton(false);
            }
        }
    }, [userIdentitiesAccessRequest]);



    // firma
    const createSignature = () => {
        if (signatures.length === 0) {
            SignaturesService.createSignatureNoPlan(userId)
                .then((response: any) => {
                    console.log('resposne >>> createSignature: ', response);

                    if (response.data.id !== null) {
                        setSignatures([response.data]);
                        setSignatureId(response.data.id);
                        setAlreadySignedText("Firma creada con éxito.");
                    }
                })
                .catch((error: any) => {
                    console.log('error >>> createSignature: ', error);
                    setAlreadySignedText("Se ha producido un error al firmar el contrato. Por favor, inténtelo de nuevo más tarde.");
                })
                .finally(() => {
                    setValidatingAcceptSignature(false);
                    setIsLoadedSignature(true);
                });
        }
    };

    // Rechazo de la solicitud de acceso
    const onRejectAccessRequestSubmit = async () => {
        // deshabilita los botones de aceptar y rechazar
        setDisabledRejectButton(true);
        setDisabledAcceptButton(true);
        // spinner botónm rechazar
        setValidatingRejectSignature(true);
        // no mostrar el componente de firma
        setShowSignatureComponent(false);
        try {
            const updatedAccessRequest = {
                ...accessRequest[0], 
                status: UserIdentityRequestStatusEnum.Rejected,
                updatedAt: moment().format("YYYY-MM-DD")

            } as AccessRequestDto;
            const response = await UserIdentitiesService.patchAccessRequestStatus(updatedAccessRequest);
            
            if (response) {
                setAccessRequest([updatedAccessRequest]);
            }
        } catch (error) {
            console.error("Error al actualizar el estado de la solicitud de acceso:", error);
            // Si hay error, se vuelven a habilitar los botones
            setDisabledRejectButton(false);
            setDisabledAcceptButton(false);
            // mostrar algún mensaje de error
        } finally {
            setValidatingRejectSignature(false);
        }
    };
    
    // Aceptar solicitud de acceso
    const onAcceptAccessRequestSubmit = (signatureId: number) => {   
        try {
            const updatedAccessRequest = {
                ...accessRequest[0], 
                status: UserIdentityRequestStatusEnum.Approved,
                sign: signatureId!,
                approvalDate: moment().format("YYYY-MM-DD")
            }as AccessRequestDto;
            const response = UserIdentitiesService.patchAccessRequestStatus(updatedAccessRequest);
            response.then((res) => {
                if(res) {
                    setAccessRequest([updatedAccessRequest]);
                }
            });
        } catch (error) {
            console.error("Error al actualizar el estado de la solicitud de acceso:", error);
            // Si hay error, se vuelven a habilitar los botones
            setDisabledRejectButton(false);
            setDisabledAcceptButton(false);
        }
    }

    const handleSignSubmit = (response: any) => {
        if (response && response.status === 200) {
            setIsSignSubmitted(true);
            setSignatureId(signatures[0]?.id!);
            onAcceptAccessRequestSubmit(signatures[0]?.id!);
        }
    };

    const processExpirationDate = (signs: ISignature[]) => {
        if (signs !== undefined && signs.length > 0) {
            // eslint-disable-next-line array-callback-return
            signs.map((signature: ISignature) => {
                if (signature && typeof signature.expiresAt === "string") {
                    signature.expiresAt = moment(signature.expiresAt).toDate();
                }
            });
        }
    }

    return (
        <>
            <Modal
                isOpen={showModal}
                onDismiss={() => handleCloseModalExistingAccount(false)}
                isBlocking={false}
                containerClassName="modal-container-RequestAuthorization"
            >
                <div style={{ fontFamily: "Barlow", fontSize: "14px" }}>
                    <div style={{ width: "100%", marginBottom: "20px", textAlign: "right" }}>
                        <b style={{ float: "left", fontSize: "24px" }}>Estado de solicitudes de acceso</b>
                        <IconButton iconProps={cancelIcon}  style={{ right: "24px" }} ariaLabel="Cerrar modal" onClick={() => handleCloseModalExistingAccount(false)} />
                    </div>
                    <div>
                        <div style={{ width: "100%", overflow: "hidden", marginTop: "10px" }}>
                            <ModalRequestAuthorizationTable>
                                <tbody>
                                    <tr>
                                        <th>Solicitante</th>
                                        <th>Interviniente</th>
                                        <th>Estado</th>
                                        <th>Fecha del último estado</th>
                                        <th className="actions">{}</th>
                                    </tr>
                                    {isLoading && (
                                        <tr>
                                            <td colSpan={5} style={{ textAlign: "center", padding: "20px 0" }}>
                                                <Spinner size={SpinnerSize.large} />
                                            </td>
                                        </tr>
                                    )}
                                    {!isLoading && (accessRequest.length > 0) && (
                                            <tr>
                                                <td>
                                                    {accessRequest[0].requestingUserIdentity?.firstName! + " " +
                                                    accessRequest[0].requestingUserIdentity?.lastName! + " " +
                                                    accessRequest[0].requestingUserIdentity?.secondLastName!}
                                                </td>
                                                <td>
                                                    {selectedUserIdentity?.firstName! + " " + selectedUserIdentity?.lastName! + " " + selectedUserIdentity?.secondLastName!} 
                                                </td>
                                                <td>
                                                    <StatusPill status={getStatus(accessRequest[0].status)} type="small" />
                                                </td>
                                                <td>
                                                    {moment(accessRequest[0].updatedAt).format("DD/MM/YYYY")}
                                                </td>
                                                <td>
                                                    <div style={{ width: "100%", textAlign: "end", display: "flex", justifyContent: "space-between" }}>
                                                        <DefaultButton
                                                            className="button mini-primary-button"
                                                            disabled={isSignSubmitted || isSignSubmitting || disabledAcceptButton}
                                                            style={{ minWidth: "90px" }}
                                                            onClick={() => {
                                                                setShowSignatureComponent(true);
                                                                setIsSignSubmitting(true);
                                                                createSignature();
                                                                setValidatingAcceptSignature(true);
                                                            }}
                                                        >
                                                            Aceptar
                                                            {validatingAcceptSignature && (
                                                                <div style={{ paddingLeft: "5px" }}>
                                                                    <Spinner size={SpinnerSize.small} className="button-spinner" />
                                                                </div>
                                                            )}
                                                        </DefaultButton>
                                                        <DefaultButton
                                                            className="button mini-primary-button"
                                                            disabled={isSignSubmitted || isSignSubmitting || disabledRejectButton}
                                                            style={{ minWidth: "90px" }}
                                                            onClick={() => {
                                                                onRejectAccessRequestSubmit();
                                                            }}
                                                        >
                                                            Rechazar
                                                            {validatingRejectSignature && (
                                                                <div style={{ paddingLeft: "5px" }}>
                                                                    <Spinner size={SpinnerSize.small} className="button-spinner" />
                                                                </div>
                                                            )}
                                                        </DefaultButton>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </ModalRequestAuthorizationTable>
                        </div>
                    </div>
                    <div>
                        {showSignatureComponent && signatures.length > 0 && (
                            <SignatureComponentWrapper>
                                <SignatureComponent
                                    signatures={signatures}
                                    submitButtonText="Firmar solicitud"
                                    headerTextArea={"Recibirás un SMS en el teléfono con la clave para firmar esta operación."}
                                    cancelButtonText=""
                                    alreadySignedText={alreadySignedText}
                                    backButtonText="Volver"
                                    requestNewCodeButtonText="Recibir nuevo código"
                                    onCancelButtonClicked={() => {
                                        setIsSignSubmitting(false);
                                        setShowSignatureComponent(false);
                                    }}
                                    onBackButtonClicked={() => setIsSignSubmitting(false)}
                                    onNewCodeSended={(signatures) => {
                                        processExpirationDate(signatures);
                                        setSignatures(signatures);
                                    }}
                                    onSignatureChanged={(signatures) => {
                                        processExpirationDate(signatures);
                                        setSignatures(signatures);
                                    }}
                                    onSigned={handleSignSubmit}
                                />
                            </SignatureComponentWrapper>
                        )}
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ModalRequestAuthorization;
